import React from "react";
import SideBar from "../components/layout/SideBar";

export default function Administration() {
    return (
        <div>
            <SideBar />
        </div>
    );
}